import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './redux/reducers'
import thunk from "redux-thunk"
import { save, load } from "redux-localstorage-simple"
const devTools =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(thunk, save({ namespace: "sams_v2" }))
    : composeWithDevTools(applyMiddleware(thunk, save({ namespace: "sams_v2" })));
const store = createStore(rootReducer, load({ namespace: "sams_v2" }), devTools);
export default store;
//const initialState = {
//  sidebarShow: true,
//}

//const changeState = (state = initialState, { type, ...rest }) => {
//  switch (type) {
//    case 'set':
//      return { ...state, ...rest }
//    default:
//      return state
//  }
//}

//const store = createStore(changeState)
//export default store
